// Giá trị có thể bị lưu thô (không phải JSON), ví dụ JWT do app khác cùng localhost:3000 ghi
const parseStored = (key: string): any => {
  const value = localStorage.getItem(key) || "{}";
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const getLocalRefreshToken = (): string | null => {
  return parseStored("refreshToken");
};

const getLocalAccessToken = (): string | null => {
  return parseStored("token");
};

const updateLocalAccessToken = (token: string): void => {
  let user = JSON.parse(localStorage.getItem("user") || "{}");
  user.token = token;
  localStorage.setItem("user", JSON.stringify(user));
};

const getUser = (): any => {
  return JSON.parse(localStorage.getItem("user") || "{}");
};

const setUser = (user: any): void => {
  localStorage.setItem("id", JSON.stringify(user?.id));
  localStorage.setItem("token", JSON.stringify(user?.jwt));
  localStorage.setItem("refreshToken", JSON.stringify(user?.refreshToken));
};

const removeUser = (): void => {
  localStorage.removeItem("id");
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
};

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  getUser,
  setUser,
  removeUser,
};

export default TokenService;
